
import { Component, Vue, Watch } from 'vue-property-decorator';
import { initClient } from '../../../../api';
import { GroupUserExternal, MediaApiControllerUIClient, MediaItem } from '../../../backend/backendapi';
import $ from 'jquery';

@Component
export default class PictureModal extends Vue {
  private readonly api = initClient(MediaApiControllerUIClient);

  externalUser: GroupUserExternal | null = null;
  media: MediaItem | null = null;

  public open(externalUser: GroupUserExternal): void {
    this.externalUser = externalUser;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
    this.externalUser = null;
  }

  @Watch('externalUser.mediaId', { immediate: true })
  async onMediaIdChanged(): Promise<void> {
    this.media = null;
    if (!this.externalUser?.mediaId) {
      return;
    }
    this.media = await this.api.get(this.externalUser.mediaId);
  }
}
